import { render } from "./cooling.vue?vue&type=template&id=a824cd54&scoped=true"
const script = {}

import "./cooling.vue?vue&type=style&index=0&id=a824cd54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a824cd54"

export default script